<template>
  <div id="app">
    <!--    头部-->
    <HeadMenu v-show="showType" />
    <router-view @showType="recvShowType" />
    <Footer v-show="showType" />
    <!--    底部-->
  </div>
</template>

<script>
import HeadMenu from "./view/headMenu";
import Footer from "./view/footer";
// import DevicePixelRatio from '../util/devicePixelRatio'
export default {
  name: "App",
  components: { Footer, HeadMenu },
  // created () {
  //   new DevicePixelRatio().init()
  // },
  // mounted () {
  //   window.onresize = () => {
  //     return (() => {
  //       this.detectZoom()
  //     })()
  //   }
  // },
  // methods: {
  //   detectZoom () {
  //     // eslint-disable-next-line one-var
  //     var ratio = 0,
  //       screen = window.screen,
  //       ua = navigator.userAgent.toLowerCase()
  //     if (window.devicePixelRatio !== undefined) {
  //       ratio = window.devicePixelRatio
  //     } else if (~ua.indexOf('msie')) {
  //       if (screen.deviceXDPI && screen.logicalXDPI) {
  //         ratio = screen.deviceXDPI / screen.logicalXDPI
  //       }
  //     } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
  //       ratio = window.outerWidth / window.innerWidth
  //     }
  //
  //     if (ratio) {
  //       ratio = Math.round(ratio * 100)
  //     }
  //     // ratio就是获取到的百分比
  //     console.log(ratio)
  //     this.onresize_height = ratio
  //     // return ratio;
  //   }
  // }

  data() {
    return {
      showType: 1,
    };
  },
  methods: {
    recvShowType(param) {
      // console.log("app recvShowType:", param);
      this.showType = param;
    },
  },
};
</script>

<style>
/*#app {*/
/*  font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
/*  -webkit-font-smoothing: antialiased;*/
/*  -moz-osx-font-smoothing: grayscale;*/
/*  text-align: center;*/
/*  color: #2c3e50;*/
/*  margin-top: 60px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/App.vue